import UFunction from "./UFunction.mts";

namespace UPromise {
  export type Maybe<T> = T | Promise<T>;
  export type Awaitable<T> = T | PromiseLike<Awaitable<T>>;

  export const delay = (ms: number) =>
    new Promise<void>((resolve) => setTimeout(resolve, ms));

  export const deferrable = <T,>(promise: Promise<T>) =>
    new Promise<T>((resolve, reject) => {
      promise.then(resolve, reject);
    });

  export const forever = new Promise(UFunction.noop);
}

export default UPromise;
